<template>
  <b-card class="shadow atm-rounded">
    <section v-if="totalCoinsToDate">
      <table class="w-100 table table-bordered">
        <thead>
          <tr>
            <th>
              <b-card-title class="m-0">Total Coins To date</b-card-title>
            </th>
            <th class="text-center">
              <b-img :src="coinImg" class="coinImg"></b-img>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="module in totalCoinsToDate.coinsByModules" :key="module.id">
            <td>
              <b-img :src="module.icon" class="coinImg mr-2" />
              {{ module.name }}
            </td>
            <td class="text-center w-20">{{ module.totals }}</td>
          </tr>
          <tr class="total-earned">
            <td>Total earned</td>
            <td class="text-center w-20">{{ totalCoinsToDate.allCoins }}</td>
          </tr>
          <tr>
            <td>Coins spent</td>
            <td class="text-center">{{ totalCoinsToDate.clamedCoins }}</td>
          </tr>
          <tr>
            <td>Coins available in bank</td>
            <td class="text-center">{{ totalCoinsToDate.BankedCoins }}</td>
          </tr>
          <tr>
            <td>Pending coins</td>
            <td class="text-center">{{ totalCoinsToDate.pendingCoins }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </b-card>
</template>

<script>
export default {
  props: {
    coinsToDate: Object,
  },
  data() {
    return {
      coinImg: require('@/assets/coin2.png'),
      totalCoinsToDate: null,
    };
  },
  watch: {
    coinsToDate: {
      handler(newVal) {
        if (newVal) this.totalCoinsToDate = newVal;
      },
      immediate: true,
    },
  },
};
</script>
